import { CollectionFilter } from "@/modules/DashboardTemplate/models/CollectionFilter";
import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";

export function getCollectionFilter(
  sections: SectionOfDashboard[],
  indexSectionOfDashboard: number,
  indexCollectionFilter: number
): CollectionFilter | null {
  const section = sections?.[indexSectionOfDashboard];
  const dataToGraph = section?.collections?.[indexCollectionFilter];

  if (
    !dataToGraph.chartData ||
    Object.keys(dataToGraph.chartData).length === 0
  ) {
    return null;
  }

  return dataToGraph;
}
